/**
 * Fixtures for the offline lane.
 *
 * The prototype runtime renders from seeded stores when there is no JWT, which
 * is how the rider product is demonstrated without a server. Only the fields
 * the rider screens actually read are listed: this file used to carry a full
 * pre-split fixture set (chefs, order stats, an active order) for a customer
 * home that no longer exists here, and every unused field was a way for the
 * demo and the real projection to look the same while disagreeing.
 */

export interface DemoOffer {
  merchant: string
  pickup: string
  dropoff: string
  payNgn: number
  distanceKm: number
  etaMins: number
  surge?: boolean
}

export const demoOffers: readonly DemoOffer[] = [
  {
    merchant: 'Jollof Republic',
    pickup: 'Yaba',
    dropoff: 'Akoka',
    payNgn: 1850,
    distanceKm: 3.2,
    etaMins: 14,
    surge: true,
  },
  {
    merchant: 'Suya Lab',
    pickup: 'Ikeja GRA',
    dropoff: 'Maryland',
    payNgn: 1400,
    distanceKm: 4.8,
    etaMins: 19,
  },
  {
    merchant: 'Green Bowl',
    pickup: 'Victoria Island',
    dropoff: 'Lekki Phase 1',
    payNgn: 2600,
    distanceKm: 6.1,
    etaMins: 24,
    surge: true,
  },
]

export interface DemoStat {
  label: string
  value: string
  hint: string
  tone: 'brand' | 'success' | 'info' | 'warning'
}

export const dashStats: readonly DemoStat[] = [
  { label: "Today's earnings", value: '₦18,400', hint: '11 trips completed', tone: 'success' },
  { label: 'Acceptance', value: '94%', hint: 'last 50 offers', tone: 'brand' },
  { label: 'Online time', value: '5h 12m', hint: 'peak window active', tone: 'info' },
  { label: 'Rating', value: '4.92', hint: 'across 312 trips', tone: 'warning' },
]

export const dashSession = {
  zone: 'Yaba · Akoka cluster',
  demand: 'High demand',
  nextPayout: '₦18,400 · cashout ready',
}
